import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Link, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { AuditSource } from './auditData';

const SourceLink = ({ source }: { source: AuditSource }) => {
  const { palette } = useTheme();

  if (!source.link) {
    return (
      <Typography color={palette.colors.grey[700]} variant='font12'>
        {source.title}
      </Typography>
    );
  }
  return (
    <Link
      href={source.link}
      rel='noopener noreferrer'
      sx={{ width: 'fit-content' }}
      target='_blank'
      variant='font12'
    >
      {source.title}
    </Link>
  );
};

// Knowledge sources are cited, never quoted: the first article as a link, and a
// count that expands to the rest. Article content deliberately never renders in
// the drawer.
export const SourceLinks = ({ sources }: { sources: AuditSource[] }) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { palette } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [first, ...rest] = sources;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <SourceLink source={first} />
      {rest.length > 0 && (
        <Box
          aria-expanded={isOpen}
          component='button'
          onClick={() => setIsOpen(open => !open)}
          sx={{
            alignSelf: 'flex-start',
            background: 'none',
            border: 0,
            cursor: 'pointer',
            font: 'inherit',
            p: 0,
            textAlign: 'left',
            textDecoration: 'underline',
          }}
        >
          <Typography color={palette.colors.grey[700]} variant='font12'>
            {isOpen
              ? t('conversationAudit.hideSources')
              : t('conversationAudit.moreSources', { count: rest.length })}
          </Typography>
        </Box>
      )}
      {isOpen &&
        rest.map(source => (
          <SourceLink key={source.documentId} source={source} />
        ))}
    </Box>
  );
};
